import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';
import 'firebase/analytics';

firebase.initializeApp({
  apiKey: 'AIzaSyCjDCDnCi7PFNbgETCkXW7Xne11RaGJWg4',
  authDomain: 'lpbd-team-3.firebaseapp.com',
  projectId: 'lpbd-team-3',
  storageBucket: 'lpbd-team-3.appspot.com',
  messagingSenderId: '1056081971438',
  appId: '1:1056081971438:web:394c24e82c9fef3b8b8bff',
  measurementId: 'G-Y1L8RH49WR',
});

export const analytics = firebase.analytics();
export const auth = firebase.auth();
export const firestore = firebase.firestore();
